import { render } from "./Form.vue?vue&type=template&id=2b33b980&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=2b33b980&scoped=true&lang=css"
import "./Form.vue?vue&type=style&index=1&id=2b33b980&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b33b980"]])

export default __exports__